import Button from "@app/components/button";
import { addToast } from "@app/components/toast/toast.service";
import { SystemMessage } from "@app/constants";
import { Purchase } from "@app/types";
import { fancyTimeFormat, formatMoneyVN, fromUnixTime } from "@app/utils/util";
import { Images } from "@assets/images";
import { useCopyToClipboard } from "@core/hooks/use-copy-to-clipboard.hook";
import { useCountdown } from "@core/hooks/use-countdown.hook";
import { useEffect } from "react";
import { UpgradeStep } from "../upgrade.page";

interface StepThreeProps {
  purchase?: Purchase;
  handleSetStep: (step: UpgradeStep) => void;
}

function StepThree({ purchase, handleSetStep }: StepThreeProps) {
  const [, copy] = useCopyToClipboard();
  const [count, { startCountdown }] = useCountdown({
    countStart: fromUnixTime(purchase!.expiredTime).diff(new Date(), "seconds"),
  });

  const handleCopyClick = (text: string) => {
    copy(text).then(() => {
      addToast({ text: SystemMessage.COPY_SUCCESSFULLY });
    });
  };

  useEffect(() => {
    startCountdown();
  }, []);

  useEffect(() => {
    if (count <= 0) {
      addToast({ text: SystemMessage.TIMEOUT, status: "inValid" });
      handleSetStep(UpgradeStep.TWO);
    }
  }, [count]);

  const handleCancelClick = () => {
    handleSetStep(UpgradeStep.TWO);
  };

  const handleTransferredClick = () => {
    addToast({ text: SystemMessage.TRANSFER_SUCCESSFULLY });
    handleSetStep(UpgradeStep.TWO);
  };

  return (
    <>
      {!!purchase && (
        <div className="flex flex-col mt-16">
          <div className="font-[SVN-Gilroy] font-semibold text-[#FC4040] text-center">
            Thời gian còn lại: {fancyTimeFormat(count)}
          </div>
          <div className="mt-10 w-[580px] mx-auto">
            <div className="font-[SVN-Gilroy] font-medium">
              Ngân hàng: {purchase.bankName}
            </div>
            <div className="font-[SVN-Gilroy] font-medium mt-3">
              Chủ tài khoản: {purchase.ownerName}
            </div>
            <div className="flex justify-between mt-3">
              <div className="font-[SVN-Gilroy] font-medium">
                Số tài khoản: {purchase.bankNumber}
              </div>
              <img
                src={Images.CopyPayment.default}
                alt=""
                className="cursor-pointer"
                onClick={() => handleCopyClick(purchase.bankNumber)}
              />
            </div>
            <div className="flex justify-between mt-3">
              <div className="font-[SVN-Gilroy] font-medium">
                Số tiền:{" "}
                <span className="font-semibold">
                  {formatMoneyVN(purchase.price)} VND
                </span>
              </div>
              <img
                src={Images.CopyPayment.default}
                alt=""
                className="cursor-pointer"
                onClick={() => handleCopyClick(purchase.price.toString())}
              />
            </div>
            <div className="flex justify-between mt-3">
              <div className="font-[SVN-Gilroy] font-medium">
                Nội dung: {purchase.content}
              </div>
              <img
                src={Images.CopyPayment.default}
                alt=""
                className="cursor-pointer"
                onClick={() => handleCopyClick(purchase.content)}
              />
            </div>
            <div className="w-[400px] h-[400px] mt-[60px] mx-auto">
              <img src={purchase.qrCode} className="w-full h-full" alt="" />
            </div>
          </div>
        </div>
      )}
      <div className="flex justify-center gap-6">
        <Button
          width="auto"
          className="!w-[292px] mt-[76px] !h-[42px] font-bold !rounded-[26px] !bg-[#DFE2E7]"
          label="Hủy"
          labelClassName="font-[SVN-Gilroy] text-lg tracking-[0.027px] text-[#3A4251]"
          containerClassName="flex justify-center"
          onClick={handleCancelClick}
        />
        <Button
          width="auto"
          className="!w-[292px] mt-[76px] !h-[42px] font-bold bg-gradient-to-b from-[#49C172] to-[#288564] !rounded-[26px]"
          label="Đã chuyển"
          labelClassName="font-[SVN-Gilroy] text-lg tracking-[0.027px]"
          containerClassName="flex justify-center"
          onClick={handleTransferredClick}
        />
      </div>
    </>
  );
}

export default StepThree;
